import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import * as getters from './getters'
import auth from './modules/auth'
import account from './modules/account'
import ideas from './modules/ideas'
import db from './modules/db'
import domain from './modules/domain'

Vue.use(Vuex)

const debug = true

const state = {
    showInfo: false,
    waitLoading: false,
    showLoading: false,
    search: '',
    showSearch: false,
    searchResults: {
        byDesc: [],
        byTitle: []
    }
};

const mutations = {
    "WAIT_LOADING": (state, data) => {
        state.waitLoading= !!data;
    },
    "SET_LOADING": (state, data) => {
        state.showLoading = !!data;
    },
    "SET_SHOWSEARCH": (state, data) => {
        state.showSearch = data;
    },
    'SET_SEARCHTERM' (state, data) {
        state.search = data;
        state.searchResults = {};
        if (!data) {
            state.showSearch = false;
        }
    },
    'SET_SEARCH_RESULTS' (state, data) {
        state.searchResults = data
    },
    'SET_SHOWINFO' (state, data) {
        state.showInfo = data
    }

}

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        ideas,
        auth,
        account,
        db,
        domain
    },
    string: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js